/* 料金シミュレーター（/pages/personal-gym-price・/pages/pilates-price）。
   「月に何回 × 何ヶ月」で、各ブランドのいちばん安い払い方と総額をその場で計算し、並べ替える。
   データは snippets/fp-studio-<kind>.liquid に埋め込んだ JSON（scripts/studio-price/build.mjs が作る）。テスト: scripts/test/fsp-sim.test.cjs */
(function (root) {
  var has = function (v) { return typeof v === 'number' && isFinite(v); };
  var yen = function (n) { return Math.round(n).toLocaleString('en-US') + '円'; };

  function personal(b, f, m) {
    if (!has(b.join_fee)) return null;
    var n = f * m, opts = [];
    var c = b.standard_course;
    if (c && !b.sim_skip_course && has(c.price) && has(c.sessions) && c.sessions > 0) {
      var k = Math.ceil(n / c.sessions);
      opts.push({ cost: c.price * k, how: c.sessions + '回コース×' + k });
    }
    var mp = b.monthly_plan;
    if (mp && has(mp.price) && has(mp.sessions_per_month) && mp.sessions_per_month >= f) {
      opts.push({ cost: mp.price * m, how: '月' + mp.sessions_per_month + '回プラン×' + m + 'ヶ月' });
    }
    var ps = b.per_session_course;
    if (ps && has(ps.price) && has(ps.sessions) && ps.sessions > 0) {
      var unit = ps.price / ps.sessions;
      var base = has(b.membership_monthly) ? b.membership_monthly * m : 0;
      opts.push({ cost: base + unit * n, how: (base ? '月会費×' + m + 'ヶ月＋' : '') + (ps.sessions > 1 ? ps.sessions + '回券の1回分' : '1回ごと') + '×' + n + '回' });
    }
    if (!opts.length) return null;
    opts.sort(function (a, b2) { return a.cost - b2.cost; });
    var total = b.join_fee + opts[0].cost;
    return { total: Math.round(total), perSession: Math.round(total / n), how: opts[0].how + (b.join_fee ? '＋入会金' : '') };
  }

  var PIL = { pilates: 1, yoga: 1 };

  function pilates(b, f, m, opt) {
    if (!has(b.join_fee)) return null;
    var fmt = opt && opt.format;
    var ok = (b.plans || []).filter(function (p) {
      if (!has(p.price_monthly)) return false;
      if (fmt && fmt !== 'all' && p.type !== fmt) return false;
      return p.sessions_per_month == null || (has(p.sessions_per_month) && p.sessions_per_month >= f);
    }).sort(function (a, c) { return a.price_monthly - c.price_monthly; });
    if (!ok.length) return null;
    var p = ok[0];
    var adm = has(b.admin_fee_monthly) ? b.admin_fee_monthly : 0;
    var total = b.join_fee + (p.price_monthly + adm) * m;
    return { total: Math.round(total), perSession: Math.round(total / (f * m)), how: (p.name || '') + '×' + m + 'ヶ月' + (adm ? '＋施設費' : '') + (b.join_fee ? '＋入会金' : ''), type: p.type };
  }

  function rankAll(brands, o) {
    var list = brands.filter(function (b) {
      if (o.women && !b.women_only) return false;
      if (o.online && !b.online) return false;
      if (o.refund && !b.refund_guarantee) return false;
      return true;
    }).map(function (b) {
      var sim = PIL[o.kind] ? pilates(b, o.f, o.m, { format: o.format }) : personal(b, o.f, o.m);
      return Object.assign({}, b, { sim: sim });
    });
    list.sort(function (a, b) { return (a.sim ? a.sim.total : Infinity) - (b.sim ? b.sim.total : Infinity); });
    return list;
  }

  var api = { personal: personal, pilates: pilates, rankAll: rankAll, yen: yen };
  if (typeof module === 'object' && module.exports) { module.exports = api; return; }
  root.FSPSim = api;

  // ---- 画面: 条件を変えるたびに並べ替え（位置の移動をアニメーション）・数字をカウント ----
  function init() {
    var box = document.querySelector('[data-fsp-sim]');
    var dataEl = document.getElementById('fsp-sim-data');
    var list = document.getElementById('fsp-list');
    if (!box || !dataEl || !list) return;
    var D = JSON.parse(dataEl.textContent);
    // sim=false の間は各社の代表コース（サーバーで出した数字）のまま。通い方を選んだら計算に切り替える
    var st = { kind: D.kind, f: PIL[D.kind] ? 4 : 8, m: PIL[D.kind] ? 3 : 2, women: false, online: false, refund: false, format: 'all', sim: false };
    var order = D.brands.map(function (b) { return b.key; });
    var cards = {};
    Array.prototype.forEach.call(list.querySelectorAll('[data-key]'), function (el) { cards[el.getAttribute('data-key')] = el; });
    var out = box.querySelector('[data-fsp-out]');
    var best = box.querySelector('[data-fsp-best]');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    function count(el, to) {
      var from = Number(el.getAttribute('data-v') || to);
      el.setAttribute('data-v', to);
      if (reduce || from === to || document.hidden) { el.textContent = yen(to); return; }
      var t0 = performance.now();
      (function step(t) {
        var p = Math.min(1, (t - t0) / 380); p = 1 - Math.pow(1 - p, 3);
        el.textContent = yen(from + (to - from) * p);
        if (p < 1) requestAnimationFrame(step);
      })(t0);
    }

    function stdList() {
      return D.brands.filter(function (b) {
        if (st.women && !b.women_only) return false;
        if (st.online && !b.online) return false;
        if (st.refund && !b.refund_guarantee) return false;
        if (st.format !== 'all' && !(b.plans || []).some(function (p) { return p.type === st.format; })) return false;
        return true;
      }).map(function (b) { var el = cards[b.key], t = el && el.querySelector('[data-sim-total]'); return Object.assign({}, b, { std: t ? Number(t.getAttribute('data-v')) : null }); })
        .sort(function (a, b) { return order.indexOf(a.key) - order.indexOf(b.key); });
    }
    function render() {
      if (!st.sim) return renderStd();
      Array.prototype.forEach.call(box.querySelectorAll('button[data-k="f"]'), function (x) { x.setAttribute('aria-pressed', Number(x.getAttribute('data-v')) === st.f ? 'true' : 'false'); });
      var r = rankAll(D.brands, st);
      var first = {};
      Object.keys(cards).forEach(function (k) { first[k] = cards[k].getBoundingClientRect().top; });
      var shown = {};
      var n = 0, max = 0;
      r.forEach(function (b) { if (b.sim) max = Math.max(max, b.sim.total); });
      r.forEach(function (b) {
        var el = cards[b.key]; if (!el) return;
        shown[b.key] = 1; el.hidden = false; list.appendChild(el);
        var rank = el.querySelector('.fsp-rank'), tot = el.querySelector('[data-sim-total]'), per = el.querySelector('[data-sim-per]'), how = el.querySelector('[data-sim-how]'), bar = el.querySelector('[data-sim-bar]');
        if (b.sim) {
          n++; rank.textContent = n; rank.classList.remove('is-na');
          if (tot) count(tot, b.sim.total);
          if (per) count(per, b.sim.perSession);
          if (how) how.textContent = b.sim.how;
          if (bar) bar.style.width = Math.max(6, Math.round(b.sim.total / max * 100)) + '%';
          el.classList.remove('is-off');
        } else {
          rank.textContent = '-'; rank.classList.add('is-na');
          if (tot) { tot.textContent = 'この条件では計算できません'; tot.removeAttribute('data-v'); }
          if (per) { per.textContent = '-'; per.removeAttribute('data-v'); }
          if (how) how.textContent = '';
          if (bar) bar.style.width = '0';
          el.classList.add('is-off');
        }
      });
      Object.keys(cards).forEach(function (k) { if (!shown[k]) cards[k].hidden = true; });
      if (!reduce) Object.keys(shown).forEach(function (k) {
        var el = cards[k], dy = first[k] - el.getBoundingClientRect().top;
        if (!dy) return;
        el.style.transition = 'none'; el.style.transform = 'translateY(' + dy + 'px)';
        requestAnimationFrame(function () { el.style.transition = 'transform .45s cubic-bezier(.22,.61,.36,1)'; el.style.transform = ''; });
      });
      var top = r.filter(function (b) { return b.sim; })[0];
      if (out) out.textContent = '月' + st.f + '回 × ' + st.m + 'ヶ月（計' + st.f * st.m + '回）で計算';
      if (best) best.innerHTML = top ? '<span>この条件でいちばん安い</span><b>' + top.name.replace(/[<>&]/g, '') + '</b><em>総額 ' + yen(top.sim.total) + '（1回 ' + yen(top.sim.perSession) + '）</em>' : '<span>条件に合うブランドがありません</span>';
    }

    function renderStd() {
      var r = stdList(), shown = {}, max = 0;
      r.forEach(function (b) { if (b.std) max = Math.max(max, b.std); });
      r.forEach(function (b, i) {
        var el = cards[b.key]; if (!el) return;
        shown[b.key] = 1; el.hidden = false;
        el.querySelector('.fsp-rank').textContent = i + 1;
        var bar = el.querySelector('[data-sim-bar]'); if (bar && b.std) bar.style.width = Math.max(6, Math.round(b.std / max * 100)) + '%';
      });
      Object.keys(cards).forEach(function (k) { if (!shown[k]) cards[k].hidden = true; });
      var top = r[0], el = top && cards[top.key];
      if (best) best.innerHTML = top ? '<span>代表' + (PIL[D.kind] ? 'プラン' : 'コース') + 'でいちばん安い</span><b>' + top.name.replace(/[<>&]/g, '') + '</b><em>1回 ' + el.querySelector('[data-sim-per]').textContent + '</em>' : '<span>条件に合うブランドがありません</span>';
    }

    box.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-k]'); if (!b) return;
      var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
      if (k === 'women' || k === 'online' || k === 'refund') { st[k] = !st[k]; b.setAttribute('aria-pressed', st[k] ? 'true' : 'false'); }
      else {
        st[k] = k === 'format' ? v : Number(v);
        if (k === 'f') st.sim = true;
        Array.prototype.forEach.call(box.querySelectorAll('button[data-k="' + k + '"]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      }
      render();
    });
    var range = box.querySelector('input[data-k="m"]');
    if (range) range.addEventListener('input', function () { st.m = Number(range.value); st.sim = true; var l = box.querySelector('[data-m-label]'); if (l) l.textContent = st.m + 'ヶ月'; render(); });
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})(this);
